import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';

export default function ShowcaseExperience({ rig }) {
  if (!rig.experience_text && !rig.full_description) return null;

  return (
    <section className="py-24 px-6 lg:px-10 border-t border-white/5">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-primary text-xs font-bold tracking-widest mb-3 flex items-center justify-center gap-2">
            <Flame className="w-3.5 h-3.5" /> THE EXPERIENCE
          </p>
          <h2 className="text-white font-black text-3xl md:text-5xl uppercase leading-tight">
            More Than A Game
          </h2>
        </div>

        {rig.experience_text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-white/60 text-base md:text-lg leading-relaxed space-y-4 whitespace-pre-line"
          >
            {rig.experience_text}
          </motion.div>
        )}

        {rig.full_description && !rig.experience_text && (
          <div className="text-white/60 text-base leading-relaxed space-y-4 whitespace-pre-line">
            {rig.full_description}
          </div>
        )}
      </div>
    </section>
  );
}